import {app,rtdb} from "../firebase";
import {getDatabase,ref,get,set,update} from "firebase/database"
import { createNewCompany } from "./companyService";

const usersCollection = 'users';


/**
 * Cria um usuário secundário com email/senha no Firebase Auth e salva os dados adicionais no Firestore.
 * @param {string} email - Email do usuário (login).
 * @param {string} password - Senha do usuário.
 * @param {string} name - Nome completo do usuário.
 * @param {Array<string>} permissions - Lista de permissões (ex: ['administrador', 'financeiro']).
 * @returns {Promise<Object>} Dados do usuário criado.
 * @param {string} empresa_uid - ID da empresa associada ao usuário.
 * uid, email, password, name, permissions, role, empresa_uid, newUser
 */
export const createUser = async (newUser) => {
  const { uid, email, displayName, permissions, role, companyId, firstLogin } = newUser|| {};
  const db = getDatabase(app);

  const userRef = ref(db, `${usersCollection}/${uid}`);

  try {
    await set(userRef, {
      googleId:uid,
      name:displayName,
      email,
      permissions,
      role,
      firstLogin, 
      companyId:companyId??"", 
      createdAt: new Date().toISOString() 
    });
  } catch (error) {
    console.error("Erro ao salvar dados:", error);
    alert("Erro: " + error.message);
  }
};

export const verifyUser = async (user_id) => {
  try {
    const db = getDatabase(app);
    const userRef = ref(db, `${usersCollection}/${user_id}`);
    const snapshot = await get(userRef);
    if (snapshot.exists()) {
      return snapshot.val(); 
    } else {
      return null;
    }
  } catch (error) {
    console.error("Erro ao verificar usuário:", error);
    throw error; 
  }
};

export const create = async(uid, data) => {
    await set(ref(rtdb, `${usersCollection}/${uid}`), data);
    return data;
}

export const updateUser = async(uid, patch) =>    {
    await update(ref(rtdb, `${usersCollection}/${uid}`), patch);
}

// export const getByUid = async(uid) =>{
//   const snap = await get(ref(rtdb, `${usersCollection}/${uid}`));
//   return snap.exists() ? snap.val() : null;
// }
  /**
   * Garante que:
   *  - usuário exista em /users/{uid}
   *  - tenha um companyId (cria empresa se necessário)
   * Retorna o "user hydrated" pronto para o state do app.
   */
export const bootstrapOnLogin = async(authUser) =>    {
  const uid = authUser.uid;
  const existing = await this.verifyUser(uid);

  // --- Usuário já existe ---
  if (existing) {
    let companyId = existing.companyId;

    if (!companyId) {
      const company = await createNewCompany(uid);
      companyId = company.id;
      await this.updateUser(uid, { companyId }); // UPDATE, não sobrescreve createdAt
    }

    return {
      ...authUser,
      ...existing,
      companyId,
    };
  }

  // --- Usuário novo ---
  const company = await createNewCompany(uid);

  const newUser = {
    name: authUser.displayName ?? "",
    email: authUser.email ?? "",
    role: "master",
    permissions: [],
    firstLogin: true,
    companyId: company.id,               // ⚠️ camelCase correto
    createdAt: new Date().toISOString(),
    googleId: authUser.providerData?.[0]?.uid || null,
  };

  await this.create(uid, newUser);

  return {
    ...authUser,
    ...newUser,
  };
}


